var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container" }, [
    _c(
      "div",
      { staticClass: "modal-header" },
      [
        _c("h4", { staticClass: "modal-title" }, [
          _vm._v(
            "Assign Order" +
              _vm._s(_vm.orderIds.length > 1 ? "s" : "") +
              " to Carrier"
          ),
        ]),
        _c(
          "md-button",
          {
            staticClass: "md-simple md-just-icon md-round modal-default-button",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_c("md-icon", [_vm._v("clear")])],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "modal-body" }, [
      _vm.orderRatesFetchStatus === "pending"
        ? _c("div", { staticClass: "loading-container" }, [
            _c(
              "div",
              { staticClass: "order-info" },
              [
                _c("skeleton", {
                  attrs: {
                    height: "20px",
                    width: "60%",
                    "border-radius": "4px",
                  },
                }),
                _c("skeleton", {
                  staticStyle: { "margin-top": "8px" },
                  attrs: {
                    height: "16px",
                    width: "80%",
                    "border-radius": "4px",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "carrier-selection-skeleton" },
              [
                _c("skeleton", {
                  attrs: {
                    height: "16px",
                    width: "40%",
                    "border-radius": "4px",
                  },
                }),
                _c(
                  "div",
                  { staticClass: "carrier-dropdown-skeleton" },
                  [
                    _c("skeleton", {
                      attrs: {
                        height: "56px",
                        width: "100%",
                        "border-radius": "8px",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm.orderRatesFetchStatus === "error"
        ? _c(
            "div",
            { staticClass: "error-container" },
            [
              _c("md-icon", { staticClass: "error-icon" }, [_vm._v("error")]),
              _c("p", [
                _vm._v(
                  "Failed to load carrier service rates. Please try again."
                ),
              ]),
              _c(
                "md-button",
                {
                  staticClass: "md-primary",
                  on: { click: _vm.fetchOrderServiceRates },
                },
                [_vm._v("Retry")]
              ),
            ],
            1
          )
        : _vm.orderRatesFetchStatus === _vm.STATE_MACHINE_STATUS.Idle
        ? _c("div", [
            _c("div", { staticClass: "order-info" }, [
              _c("p", [
                _c("strong", [_vm._v(_vm._s(_vm.orderIds.length))]),
                _vm._v(
                  "\n                    order" +
                    _vm._s(_vm.orderIds.length > 1 ? "s" : "") +
                    " selected for batch carrier assignment\n                "
                ),
              ]),
              _vm.orderIds.length > 1
                ? _c("p", { staticClass: "batch-info" }, [
                    _vm._v(
                      "\n                    Only carriers with services available for\n                    "
                    ),
                    _c("em", [_vm._v("all")]),
                    _vm._v(
                      "\n                    selected orders will be shown.\n                "
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm.availableServiceRates.length === 0
              ? _c(
                  "div",
                  { staticClass: "no-rates-container" },
                  [
                    _c("md-icon", { staticClass: "info-icon" }, [
                      _vm._v("info"),
                    ]),
                    _vm.orderIds.length === 1
                      ? _c("p", [
                          _vm._v(
                            "\n                    No carrier service rates available for this order.\n                "
                          ),
                        ])
                      : _c("p", [
                          _vm._v(
                            "\n                    No carriers have services available for all " +
                              _vm._s(_vm.orderIds.length) +
                              " selected orders. Try selecting\n                    fewer orders or check individual order assignments.\n                "
                          ),
                        ]),
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "carrier-selection-container" },
                  [
                    _c("label", { staticClass: "carrier-label" }, [
                      _vm._v("Select Carrier Service for Batch Assignment:"),
                    ]),
                    _c("carrier-service-rate-dropdown", {
                      attrs: {
                        "carrier-service-rates": _vm.availableServiceRates,
                        "assigned-carrier-service-rate": null,
                      },
                      on: {
                        assignedCarrierChanged: _vm.handleCarrierSelection,
                      },
                    }),
                  ],
                  1
                ),
          ])
        : _vm._e(),
    ]),
    _c(
      "div",
      { staticClass: "modal-footer" },
      [
        _c(
          "md-button",
          {
            staticClass: "dialog-button md-primary",
            attrs: { disabled: !_vm.selectedCarrierService || _vm.isAssigning },
            on: { click: _vm.assignOrdersToCarrier },
          },
          [
            _vm.isAssigning
              ? _c("span", [_vm._v("Assigning...")])
              : _c("span", [_vm._v("Assign to Carrier")]),
          ]
        ),
        _c(
          "md-button",
          {
            staticClass: "dialog-button md-default",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_vm._v("Cancel")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }